// app/javascript/dashboard/api/captain/assistant.js
// VERSIÓN CE (MOCK): Se anulan las peticiones a la API Enterprise para evitar 404s.

class CaptainAssistantMock {
  get() {
    // Retorna una estructura vacía que el store pueda procesar sin explotar
    return Promise.resolve({ data: { payload: [] } });
  }

  playground() {
    return Promise.resolve({ data: {} });
  }

  getMetrics() {
    return Promise.resolve({ data: {} });
  }

  getFaqStats() {
    return Promise.resolve({ data: {} });
  }

  getSummary() {
    return Promise.resolve({ data: {} });
  }

  getDrilldown() {
    return Promise.resolve({ data: { payload: [] } });
  }
}

// Exportamos la clase simulada por defecto. Vite compilará sin errores.
export default new CaptainAssistantMock();